<template>
  <div class="mit-password-change-page mit-page">
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card fluid" v-if="featureToggleChangePassword">
              <v-card-title>Change Password</v-card-title>
              <v-card-subtitle class="caption">Change your CSAIL account password. </v-card-subtitle>
              <v-divider></v-divider>
              <v-stepper v-if="!finished" v-model="curr" color="green">
                  <v-stepper-header>
                      <v-stepper-step
                          v-for="(step,n) in steps"
                          :key="n"
                          :complete="stepComplete(n+1)"
                          :step="n+1"
                          :rules="[value => !!step.valid]"
                          :color="stepStatus(n+1)">
                          {{ step.name }}
                      </v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-content v-for="(step,n) in steps" :step="n+1" :key="n">
                      {{ step.name }}
                              <v-form :ref="'stepForm'" v-model="step.valid" lazy-validation>
                                  <!-- Step 1 -->
                                  <div v-if="n==0">

                                    <v-text-field v-if="userModel.role == userRoles.ADMIN" v-model="changeModel.username" label="CSAIL username" :rules="step.rules.username"></v-text-field>
                                    <div v-if="userModel.role == userRoles.USER" class="pt-5">{{changeModel.username}}</div>
                                    <v-text-field v-model="changeModel.currentPassword" label="Enter Current Password" type="password" :rules="step.rules.password"></v-text-field>
                                  </div>
                                  <div v-if="n==1">
                                    <v-text-field v-model="changeModel.newPassword" label="Enter New Password" type="password" :rules="step.rules.password"></v-text-field>
                                    <v-text-field v-model="changeModel.newPasswordConfirm" label="Enter New Password Again" type="password" :rules="step.rules.passwordConfirm"></v-text-field>
                                  </div>

                              </v-form>
                      <v-btn v-if="step.buttonsVisible.back" text @click="curr = n" :disabled="step.buttonsDisabled.back">Back</v-btn>
                      <v-btn v-if="step.buttonsVisible.next"  color="primary" @click="validate(n)" :disabled="step.buttonsDisabled.next">Next</v-btn>
                      <v-btn v-if="step.buttonsVisible.submit" color="primary" @click="submitChangePassword()" :disabled="step.buttonsDisabled.submit">Submit</v-btn>

                  </v-stepper-content>
                </v-stepper>
              <v-card v-if="finished">
                  <v-card-title>{{resultModel.title}}</v-card-title>
                  <v-card-text>
                      <v-col v-if="loading" class="d-flex justify-center align-center">
                        <v-row>
                          <BaseMitLoading class="pa-10"/>
                        </v-row>
                      </v-col>

                      <div v-if="!loading" class="pa-10">

                        <div > {{resultModel.message}}</div>
                        <v-row align="center" justify="center">
                          <v-col cols="12"><v-btn v-if="!resultModel.success" outlined color="primary" @click="tryAgain()">Try Again</v-btn></v-col>
                        </v-row>
                      </div>
                  </v-card-text>

              </v-card>
            </v-card>
            <v-card v-else>
              <v-card-title>Temporarily Disabled Password Change</v-card-title>
              <v-card-text>
                The change password feature has been remporarily been disabled. Please check back later.
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
  </div>
</template>

<script>
  import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
  import MitUserManagementService from '../services/MitUserManagementService.js';
  import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';

  export default {
    name: 'MitPasswordChangePage',
    components: {
      BaseMitLoading
    },
    data: function() {
      return {
        featureToggleChangePassword:true,
        changeModel:{
          username:'',
          currentPassword:'',
          newPassword:'',
          newPasswordConfirm:''
        },
        resultModel:{
          success:false,
          title:'',
          message:''
        },
        loading:true,//making the request
        finished:false,
        curr: 1,
        lastStep: 2,
        steps: [
            {
              name: "Current Account",
              rules: {
                password:[
                  v => !!v || 'Password is required'
                ]
              },
              valid: true,
              color:'blue',
              buttonsDisabled:{
                next:false,
                back:true,
                submit:false
              },
              buttonsVisible:{
                next:true,
                back:true,
                submit:false
              }
            },
            {
              name: "New Password",
              rules: {
                //rules for password come from backend since they are needed for api level validation, one set of rules for everyone :)
                password:[
                  v => !!v || 'Password is required',
                ],
                passwordConfirm:[
                  v => !!v || 'Confirm Password is required',
                  v => this.changeModel.newPassword === this.changeModel.newPasswordConfirm || 'Passwords must match'
                ]
              },
              valid: true,
              color:'blue',
              buttonsDisabled:{
                next:true,
                back:false,
                submit:false
              },
              buttonsVisible:{
                next:false,
                back:true,
                submit:true
              }
            }
        ],
        stepForm: []
      }
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    created() {
      this.featureToggleChangePassword = BaseMitConfigService.getFeatureEnabled('feature-change-password');

      //Get the password validation regex from the api
      MitUserManagementService.getPasswordValidation()
        .then((validation) => {
          for(let x = 0; x < validation.rules.length; x++){
            this.steps[1].rules.password.push( v => (new RegExp(validation.rules[x].rule)).test(v) || validation.rules[x].message );
          }
        })
        .catch((error) => {
          console.log('Error getting password validation',error);
        });

      this.changeModel.username = this.userModel.csailId;
    },
    methods: {
      tryAgain(){
        this.curr=1;
        this.finished = false;
        this.resultModel.message = '';
      },
      stepComplete(step) {
        return this.curr > step;
      },
      stepStatus(step) {
          if(this.curr > step){
            return 'green';
          }
          return 'blue';
      },
      validate(n) {
          this.steps[n].valid = false
          let v = this.$refs.stepForm[n].validate()
          if (v) {
              this.steps[n].valid = true
              // continue to next
              this.curr++;
          }

      },
      submitChangePassword() {
        if(this.$refs.stepForm[this.curr-1].validate()){
          this.finished = true;

          MitUserManagementService.changePassword(this.changeModel.username, this.changeModel.currentPassword, this.changeModel.newPassword, this.changeModel.newPasswordConfirm)
          .then((result) => {
            this.loading = false;
            this.resultModel.success = true;
            this.resultModel.title = 'Success';
            this.resultModel.message = result;
          })
          .catch((error) => {
            this.resultModel.success = false;
            this.resultModel.title = 'Error';
            this.resultModel.message = 'Reason: '+error;

            this.loading = false;
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
  .fluid { width: 100%;}
</style>
